// extracted by mini-css-extract-plugin
export default {"gameSettingsHeader":"GameSettings_gameSettingsHeader__hOogT","form":"GameSettings_form__XV6fZ","fieldset":"GameSettings_fieldset__dXIrC"};